import { useContext, useState } from 'react';
import { Button } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { UpdateSituationAPI } from '../../../API/CompaniesAPI';
import { CompanyContext } from '../../../Contexts/CompanyContext';
import { IResponseProps } from '../../../Interfaces/IResponseProps';
import { ISelectProps } from '../../../Interfaces/ISelectProps';
import { AllStatus } from '../../../Utils/AllContratTypes';
import { AllSteps } from '../../../Utils/AllSteps';
import useCan from '../../../Hooks/useCan';
import AntDialog from '../dialog';
import { Typography } from 'antd';

interface IModalSituationProps {
    showModal: boolean,
    toggleShowModal: () => void,
    loading: boolean,
    toggleLoading: (data: boolean) => void,
    companyId: string,
    userEmail: string
}

export default function ModalSituation ({ showModal, toggleShowModal, loading, toggleLoading, companyId, userEmail }: IModalSituationProps) {

    const canView = useCan({ rolesCan: [ "Manager", "Consultant" ] });

    const { company, getCompany } = useContext(CompanyContext);

    const [ contractTypeText, setContractTypeText ] = useState<string>("");
    const [ stepsText, setStepsText ] = useState<string>("");

    const [ contractType, setContractType ] = useState<ISelectProps>(() => {
        let contract = {} as ISelectProps;
        if (company.contractType != null) {
            contract = AllStatus[ company.contractType ];
            setContractTypeText(contract.value);
        }
        return contract;
    });


    const [ steps, setSteps ] = useState<ISelectProps>(() => {
        let step = {} as ISelectProps;
        if (company.processStep != null) {
            step = AllSteps[ company.processStep ];
            setStepsText(step.value);
        }
        return step;
    });

    const sendInfos = async () => {
        try {
            toggleLoading(true);

            await UpdateSituationAPI(companyId, contractTypeText, stepsText, userEmail).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    toast.success("Situação salva com sucesso!");
                    getCompany(company.id);
                    toggleShowModal();
                }
            }).finally(() => toggleLoading(false));
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    return (
        <AntDialog open={showModal} setOpen={toggleShowModal}>
            <AntDialog.Header>
                <div style={{ display: 'flex', width: '100%' }}>
                    <Typography style={{ fontSize: '18px' }}>Situação</Typography>
                </div>
            </AntDialog.Header>

            <AntDialog.Body>
                <div className='back-select p-3 mb-4'>
                    <span>Tipo de Contrato:</span>
                    <Select
                        onChange={(e: any) => { setContractType(e); setContractTypeText(e.value) }}
                        value={contractType}
                        options={AllStatus}
                        isDisabled={!canView}
                        className="w-100 mt-2"
                        classNamePrefix="select"
                    />
                </div>
                <div className='back-select p-3'>
                    <span>Etapa Atual do Processo:</span>
                    <Select
                        onChange={(e: any) => { setSteps(e); setStepsText(e.value) }}
                        value={steps}
                        options={AllSteps}
                        isDisabled={!canView}
                        className="w-100 mt-2"
                        classNamePrefix="select"
                    />
                </div>
            </AntDialog.Body>
            <AntDialog.Footer>
                {
                    canView &&
                    <Button onClick={sendInfos} className='btn btn-primary w-100'>
                        Salvar Informações
                    </Button>
                }
            </AntDialog.Footer>
        </AntDialog>
    )
}